import sanityClient from "@sanity/client";

export default sanityClient({
  projectId: "7fajij1w", // find this at manage.sanity.io, run `sanity init` to initialize
  dataset: "production", // this is from when we answered those question from 'sanity init'
  apiVersion: '2020-08-29',
  useCdn: true,
});
